<template>
    <div class="start-assessment-section">

        <div>
            <patient-icon class="patient-logo"/>
            <h4 class="title-assessment-sections">{{text('db.global.TYPE_GTS_SUMMARY_TITLE_E')}}</h4>
        </div>

        <div>
            <div class="patient-profile-assessment-token margin-top-xxl margin-bottom-xs"  v-model="assessmentToken">
                <span class="color-headings-text" style="font-size: 16px">
                    {{text('api.pro.startAssessmentPage.caseNumber')}}
                </span>
                <span class="color-headings-text font-size-small margin-top-xs" >
                    {{assessmentToken}}
                </span>
            </div>

            <v-text-field ref="vTextFieldPidRef"
                          id="vTextFieldPidId"
                          maxlength="32"
                          class="patient-profile-pid"
                          :class="{'input-group--focused': (this.isNavAvailable === true && this.shortcutNav.crtPatientField === 'FIELD_PID')}"
                          :label="text('api.summary.communication.patient.pid')"
                          v-model="patientProfileData.pid"
                          @focus="navFocusOnPatientPid"
                          @click="navClickOnPID"
                          @blur="savePatientPid">

            </v-text-field>
            <v-text-field id="patientCommentTextarea"
                          ref="vTextFieldPatientCommentRef"
                          maxlength="1024"
                          class="patient-profile-comment"
                          :class="{'field-highlighted': (this.isNavAvailable === true && this.shortcutNav.crtPatientField === 'FIELD_COMMENT' && this.getMustShowVitalParamsForm === false)}"
                          :placeholder="text('api.patient.comment.placeholder')"
                          v-model="patientProfileData.comment"
                          @focus="navFocusOnPatientComment"
                          @mousedown.stop
                          @click="navClickOnPatientComment"
                          @blur="savePatientComment"
                          textarea>

            </v-text-field>
        </div>
        <div id="privacyNote">
           {{text('db.product.PROD_EXPLAIN_PATIENT_PRIVACY')}}
        </div>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';
    import PatientIcon from "../../../common/components/svg/shared/patientIcon";
    const AS_PANEL = {
        PATIENT_INFO: "PATIENT_INFO"
    };

    const PATIENT_INFO_FIELD = {
        FIELD_PID: "FIELD_PID",
        FIELD_COMMENT: "FIELD_COMMENT"
    };

    export default {
        name: 'PatientProfile',
        components: {PatientIcon},
        computed: {
            ...mapGetters({
                patientProfileData: 'AssessmentStartStore/getPatientProfileData',
                patientProfileStatus: 'AssessmentStartStore/getPatientProfileStatus',
                assessmentToken: 'AssessmentStartStore/getAssessmentToken',
                getMustShowVitalParamsForm: 'VitalParametersStore/getMustShowVitalParamsForm',
            }),

            isNavAvailable() {
                return (this.shortcutNav != null && this.shortcutNav.isKeyboardNav === true && this.shortcutNav.crtPanel === 'PATIENT_INFO' && this.shortcutNav.isPanelHighlight === false);
            }

        },

        props: ["shortcutNav"],

        data() {
            return {
                patientProfileTempData: {}
            }
        },

        methods: {

            setTemporaryPatientProfileValues() {
                this.patientProfileTempData.firstName   = this.patientProfileData.firstName;
                this.patientProfileTempData.name        = this.patientProfileData.name;
                this.patientProfileTempData.phone       = this.patientProfileData.phone;
                this.patientProfileTempData.email       = this.patientProfileData.email;
                this.patientProfileTempData.pid       = this.patientProfileData.pid;
                this.patientProfileTempData.comment     = this.patientProfileData.comment;
            },

            isPatientProfileDataChanged() {
                if (this.patientProfileTempData.firstName === this.patientProfileData.firstName
                        && this.patientProfileTempData.name === this.patientProfileData.name
                        && this.patientProfileTempData.phone === this.patientProfileData.phone
                        && this.patientProfileTempData.email === this.patientProfileData.email
                        && this.patientProfileTempData.pid === this.patientProfileData.pid
                        && this.patientProfileTempData.comment === this.patientProfileData.comment ) {
                    return false;
                } else {
                    return true;
                }
            },

            navFocusOnPatientPid() {
                this.setTemporaryPatientProfileValues();

                // Place cursor at the end of the patient comment text and pid text field
                let textFieldPidId = document.getElementById("vTextFieldPidId");
                let pidLength = textFieldPidId.value.length;

                textFieldPidId.selectionStart = pidLength;
                textFieldPidId.selectionEnd = pidLength;
            },

            navFocusOnPatientComment() {
                this.setTemporaryPatientProfileValues();

                // Place cursor at the end of the patient comment text and pid text field
                let patientCommentTextareaId = document.getElementById("patientCommentTextarea");
                let commentLength = patientCommentTextareaId.value.length;

                patientCommentTextareaId.selectionStart = commentLength;
                patientCommentTextareaId.selectionEnd = commentLength;

                patientCommentTextareaId.scrollTop = patientCommentTextareaId.scrollHeight;
            },

            navClickOnPID() {
                if (this.shortcutNav !== null) {
                    this.shortcutNav.crtPanel = AS_PANEL.PATIENT_INFO;
                    this.shortcutNav.crtPatientField = PATIENT_INFO_FIELD.FIELD_PID;
                    this.shortcutNav.crtQuestion = null;
                    this.shortcutNav.isKeyboardNav = false;
                    this.shortcutNav.isFieldInEdit = true;
                    this.shortcutNav.isPanelHighlight = false;
                }
            },

            navClickOnPatientComment() {
                if (this.shortcutNav !== null) {
                    this.shortcutNav.crtPanel = AS_PANEL.PATIENT_INFO;
                    this.shortcutNav.crtPatientField = PATIENT_INFO_FIELD.FIELD_COMMENT;
                    this.shortcutNav.crtQuestion = null;
                    this.shortcutNav.isKeyboardNav = false;
                    this.shortcutNav.isFieldInEdit = true;
                    this.shortcutNav.isPanelHighlight = false;
                }

            },

            savePatientPid() {
                if (this.isPatientProfileDataChanged()) {
                    this.$store.dispatch("AssessmentStartStore/submitPatientPid", {
                        fieldName: "PID",
                        fieldValue: this.patientProfileData.pid
                    });
                }
                this.shortcutNav.isFieldInEdit = false;
            },

            savePatientComment() {
                if (this.isPatientProfileDataChanged()) {
                    this.$store.dispatch("AssessmentStartStore/submitPatientComment", {
                        fieldName: "COMMENT",
                        fieldValue: this.patientProfileData.comment
                    });
                }
                this.shortcutNav.isFieldInEdit = false;
            }
        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// src/professional/components/assessment-start/PatientProfile.vue